import React from 'react';
import { MainContainer, SidePanel, Article, HeadGear } from 'Templates';
import * as Section from './Sections';
import * as Table from './Tables';

const Formydable = () => { 
	const title = 'Formydable';
	const context = `is a form validator library that is delightfully made in react. It is so
	light with unique setting and cognitive design. the rules are
	eloquent which will make the schema so powerful yet easy to understand,
	and implement on any kind of components. unlike any other form validator library,
	formydable is complex that allows you to bend
	and shape it on almost what ever you want. furthermore, formydable is capable on working both controllable and uncontrollable form fields and to know more just read the documentation below.`;

	return (
		<>  
            <HeadGear>
                <HeadGear.Meta 
					title={`${title} - React Libraries | Mytabworks`}
					description={context.slice(0, 100)}
					image='/images/icons/icon-512x512.png'
				/>
            </HeadGear>
			<MainContainer 
				title={title}
				context={context}
				main={<FormydableMain />}
				side={<FormydableSidePanel />}
			/>
		</>
	);
};

Formydable.propTypes = {};

const FormydableMain = () => (
	<>
		<Section.Installation />
		<Section.Importing />
		<Section.GettingStarted />
		<Section.ControllableFields />
		<Section.CustomizeMessages />
		<Section.SubmittingForm />
		<Section.AdvanceDesignPattern />
		<Section.AliasedRegistry />
		<Section.FormUpdateWithDoneTypingEvent />
		<Section.AliasedRuleParameters />
		<Section.CustomizeRules />
		<Section.UpdatingRulesMessages />
		<Article title='API'>
			<Table.Rules />
			<Table.useForm />
			<Table.FormSupplier />
			<Table.useFormSupplier />
			<Table.DoneTypingEvent />
			<Article title='Validator'>
				<Table.rulesExtend />
				<Table.rulesUpdateMessage />
			</Article>
		</Article>
		<Section.Issues />
	</>
);

const FormydableSidePanel = () => {
	const list = [
		{ label: 'Installation' },
		{ label: 'Imports' },
		{
			label: 'Getting Started',
			sub: [
				{ label: 'Controllable Fields' },
				{ label: 'Customize Messages' },
				{ label: 'Submitting Form' },
				{ label: 'Advance Design Pattern' },
				{ label: 'Aliased Registry' },
				{ label: 'FormUpdate With DoneTypingEvent' },
				{ label: 'Aliased Rule Parameters' },
				{ label: 'Customize Rules' },
				{ label: 'Updating Rules Messages' },
			],
		},
		{
			label: 'API',
			sub: [
				{ label: 'Rules' },
				{
					label: 'useForm',
				},
				{ label: 'FormSupplier' },
				{ label: 'useFormSupplier' },
				{ label: 'DoneTypingEvent' },
				{
					label: 'Validator',
					sub: [
						{ label: 'Validator.rulesExtend' },
						{ label: 'Validator.rulesUpdateMessage' },
					],
				},
			],
		},
	];
	return <SidePanel.ScrollNav list={list} />;
};

export default Formydable;
